import type { Fallacy } from "./types";
import { createStory } from "./types";

export const adHominem: Fallacy = {
    id: "ad-hominem",
    name: "Ad Hominem",
    emoji: "🎯",
    category: "Menyerang Lawan",
    description:
      "Menyerang **pribadi lawan bicara** alih-alih membahas **isi argumennya**.",
    detail:
      "Ad Hominem berasal dari bahasa Latin yang artinya 'terhadap orangnya'. Alih-alih menanggapi argumen atau data, seseorang justru **menyerang karakter, latar belakang, atau identitas pribadi** lawan bicaranya.\n\nKenapa ini salah? Karena **kebenaran sebuah argumen tidak ditentukan oleh siapa yang mengatakannya**. Data tetap valid meskipun yang menyampaikan bukan seorang profesor.\n\nCara mengenali: Setiap kali seseorang merespons argumen dengan membahas pribadi si pembicara, bukan isi argumennya — itu Ad Hominem.",
    tldr: "Nyerang orangnya, bukan argumennya? Itu namanya Ad Hominem.",
    story: createStory("Ad Hominem", "🎯", {
      hook: {
        title: "Kamu pernah ngasih argumen yang valid...",
        body: "Tapi yang diserang bukan argumennya — malah **pribadi kamu yang dijadiin sasaran**.",
      },
      convo: {
        claim: "Naik motor aja sering nyenggol trotoar. **Yang gak bisa nyetir gak usah kritik transportasi.** Emang kamu pejabat?",
        response: "Siapa yang ngomong **gak nentuin bener-salahnya** argumen soal transportasi.",
      },
      reveal: {
        body: "Kamu **nyerang orangnya**, bukan argumennya. Padahal siapa yang ngomong **gak nentuin bener-salahnya** sebuah argumen.",
      },
      insight: {
        title: "Kenapa ini bahaya?",
        body: "Data tetap valid meskipun yang nyampein **bukan profesor**. Kalau setiap kritik dibales serang pribadi, gak ada diskusi yang maju.",
      },
      engagement: {
        title: "Pernah dikritik tapi yang diserang malah pribadi kamu?",
        body: "Di kantor, di medsos, atau di grup keluarga? **Share pengalaman kamu di komen!** 👇",
      },
    }),
related: ["tu-quoque", "straw-man", "red-herring"],
  };
